import type { IndexAnalysisResult, IndexIssue, IndexRecommendation } from '../models/indexAnalysisResults.ts';
import type { Index } from '../models/indexes';
import MultiValueMap from '../multiValueMap';
import findRedundantIndexes from './findRedundantIndexes';

export default function analyzeIndexes(indexes: Index[]): IndexAnalysisResult {
  const issues = new MultiValueMap<string, IndexIssue>();
  let recommendations: IndexRecommendation[] = [];

  const redundantIndexes = findRedundantIndexes(indexes);
  issues.addAll(redundantIndexes.issues);
  recommendations = recommendations.concat(redundantIndexes.recommendations);

  return {
    issues,
    recommendations,
  };
}
